var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXd = function SvgXd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.056 3.056a2.363 2.363 0 0 1 1.671-.692h7.09c.162 0 .316.064.43.177l5.212 5.214a.606.606 0 0 1 .178.428v11.09a2.364 2.364 0 0 1-2.364 2.363H6.727a2.363 2.363 0 0 1-2.363-2.364V4.728c0-.627.249-1.229.692-1.672Zm1.671.52a1.151 1.151 0 0 0-1.151 1.152v14.544a1.152 1.152 0 0 0 1.151 1.152h10.546a1.151 1.151 0 0 0 1.151-1.152V8.434l-4.857-4.858h-6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.833 9.5h-1.66l1.617 2.723-1.67 2.724h1.681l.926-1.617h.042l.926 1.617h1.691l-1.691-2.724L12.322 9.5h-1.649l-.904 1.585h-.042L8.833 9.5ZM14.248 15c.574 0 .968-.309 1.138-.723h.032v.67h1.458V9.5h-1.469v2.075h-.02c-.16-.415-.543-.766-1.15-.766-.808 0-1.595.617-1.595 2.095 0 1.415.734 2.096 1.606 2.096Zm.543-1.128c-.405 0-.639-.361-.639-.968 0-.606.234-.968.639-.968.404 0 .648.362.648.968 0 .596-.244.968-.649.968Z"
  }))));
};
export default SvgXd;